export function assertNotNullOrUndefined<T>(value: T | null | undefined, errorMessage?: string): asserts value is T {
  if (value === null || value === undefined) {
    throw new Error(errorMessage || 'value cannot be null or undefined');
  }
}

export function assertArrayNotEmpty<T>(array: T[]): [T, ...T[]] {
  if (array.length === 0) {
    throw new Error('array cannot be empty');
  }
  return array as [T, ...T[]];
}
